import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profileanalysis',
  templateUrl: './profileanalysis.component.html',
  styleUrls: ['./profileanalysis.component.css']
})
export class ProfileanalysisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
